import app from '../firebase';
import { useEffect, useState, useRef } from 'react';
import { getFirestore, getDoc, doc, addDoc, updateDoc, deleteDoc, getDocs, collection, where, query, orderBy } from 'firebase/firestore';
import { uploadBytes, ref, getStorage, getDownloadURL, deleteObject } from 'firebase/storage';
import { Navigate } from 'react-router-dom';

// components
import Nav      from '../components/profile/nav';
import Hero     from '../components/profile/hero';
import Personal from '../components/profile/personal';

import moment from 'moment';

export default function Profile() {

    const userId = localStorage.getItem('userId');
    const [isUser, setIsUser] = useState(true); // just to load, use true

    // loadings
    const [addProductLoading, setAddProductLoading] = useState(false);
    
    const [profile, setProfile] = useState();
    const hero = useRef(null);
    const picture = useRef(null);
    
    // new product
    const [name, setName]               = useState();
    const [description, setDescription] = useState();
    const [variant, setVariant]         = useState();
    const [variants, setVariants]       = useState([]);
    const [price, setPrice]             = useState();
    const [image, setImage]             = useState();
    const [gallery, setGallery]         = useState([]);
    const [imagePrev, setImagePrev]     = useState();

    // property attributes:
    const [size, setSize]               = useState(0);
    const [bedroom, setBedroom]         = useState();
    const [comfortroom, setComfortroom] = useState();
    const [parking, setParking]         = useState();
    
    const [category, setCategory]       = useState();

    const [products, setProducts]       = useState([]);
    const [services, setServices]       = useState([]);
    const [properties, setProperties]   = useState([]);

    const [itemsPrev, setItemsPrev]     = useState();

    // categories
    const [productCategories, setProductCategories]     = useState([]);
    const [propertyCategories, setPropertyCategories]   = useState([]);
    const [serviceCategories, setServiceCategories]     = useState([]);


    // categories
    const getProductCategories = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'product_categories')).then(results => results.forEach(result => x.push([result.id, result.data()])));
        setProductCategories(x);
    };

    const getPropertyCategories = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'property_categories'))
            .then(results => results.forEach(result => x.push([result.id, result.data()])));
        setPropertyCategories(x);
    };

    const getServiceCategories = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'service_categories')).then(results => results.forEach(result => x.push([result.id, result.data()])));
        setServiceCategories(x);
    };

    // products

    const addProduct = async () => {
        if (!name || !description || !price || !image) return alert('Please fill out necessary information!');

        setAddProductLoading(true);

        let name_keywords = name.toLowerCase().split(' ');
        let description_keywords = description.toLowerCase().split(' ');
        let product = await addDoc(collection(getFirestore(app), 'products'), { name, name_keywords, description, description_keywords, category, price: parseFloat(price), variants, date: new Date(), featured: false, available: true, seller: userId });

        // upload product image
        await uploadBytes(ref(getStorage(app), `products/${product.id}`), image).then(() => getDownloadURL(ref(getStorage(app), `products/${product.id}`)).then(image_url => updateDoc(doc(getFirestore(app), `products/${product.id}`), { image_url })));

        gallery.forEach(i => {
            addDoc(collection(getFirestore(app), 'gallery'), { product_id: product.id })
                .then(result_x => {
                    uploadBytes(ref(getStorage(app), `gallery/${result_x.id}`), i.image)
                        .then(result_y => {
                            getDownloadURL(ref(getStorage(app), `${result_y.metadata.fullPath}`))
                                .then(image_url => updateDoc(doc(getFirestore(app), `gallery/${result_x.id}`), { image_url }))
                        })
                })
        });
        
        setAddProductLoading(false);
        alert('Product Successfully Uploaded!');
    }

    const getProducts = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'products')).then(results => results.forEach(result => x.push([result.id, result.data()])));
        setProducts(x);
    }

    // services

    const addService = async () => {
        if (!name || !description || !price || !image) return alert('Please fill out necessary information!');

        setAddProductLoading(true);

        let name_keywords = name.toLowerCase().split(' ');
        let description_keywords = description.toLowerCase().split(' ');
        let service = await addDoc(collection(getFirestore(app), 'services'), { name, name_keywords, description, description_keywords, category, price: parseFloat(price), date: new Date(), featured: false, available: true, seller: userId });

        // upload product image
        await uploadBytes(ref(getStorage(app), `services/${service.id}`), image).then(() => getDownloadURL(ref(getStorage(app), `services/${service.id}`)).then(image_url => updateDoc(doc(getFirestore(app), `services/${service.id}`), { image_url })));

        gallery.forEach(i => {
            addDoc(collection(getFirestore(app), 'gallery'), { service_id: service.id })
                .then(result_x => {
                    uploadBytes(ref(getStorage(app), `gallery/${result_x.id}`), i.image)
                        .then(result_y => {
                            getDownloadURL(ref(getStorage(app), `${result_y.metadata.fullPath}`))
                                .then(image_url => updateDoc(doc(getFirestore(app), `gallery/${result_x.id}`), { image_url }))
                        })
                })
        });
        
        setAddProductLoading(false);
        alert('Service Successfully Listed!');
    }

    const removeService = async id => {
        await deleteDoc(doc(getFirestore(app), `services/${id}`));
        deleteObject(ref(getStorage(app), `services/${id}`));
        getServices();
    }

    const getServices = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'services')).then(results => results.forEach(result => x.push([result.id, result.data()])));
        setServices(x);
    }

    // properties

    const addProperty = async () => {

        if (!name || !description || !price || !image || isNaN(size) || isNaN(bedroom) || isNaN(comfortroom) || isNaN(parking)) {
            return alert('Please fill out necessary information!');
        }
        
        setAddProductLoading(true);

        let name_keywords = name.toLowerCase().split(' ');
        let description_keywords = description.toLowerCase().split(' ');
        let property = await addDoc(collection(getFirestore(app), 'properties'), { name, name_keywords, description, description_keywords, category, attributes: { size: parseFloat(size), bedroom: parseInt(bedroom), comfortroom: parseInt(comfortroom), parking: parseInt(parking) }, price: parseFloat(price), date: new Date(), featured: false, available: true, seller: userId });

        // upload property image
        await uploadBytes(ref(getStorage(app), `properties/${property.id}`), image)
            .then(() => getDownloadURL(ref(getStorage(app), `properties/${property.id}`)).then(image_url => updateDoc(doc(getFirestore(app), `properties/${property.id}`), { image_url })));

        gallery.forEach(i => {
            addDoc(collection(getFirestore(app), 'gallery'), { property_id: property.id })
                .then(result_x => {
                    uploadBytes(ref(getStorage(app), `gallery/${result_x.id}`), i.image)
                        .then(result_y => {
                            getDownloadURL(ref(getStorage(app), `${result_y.metadata.fullPath}`))
                                .then(image_url => updateDoc(doc(getFirestore(app), `gallery/${result_x.id}`), { image_url }))
                        })
                })
        });
        
        setAddProductLoading(false);
        alert('Product Successfully Uploaded!');
    }

    const removeProperty = async id => {
        await deleteDoc(doc(getFirestore(app), `property/${id}`));
        deleteObject(ref(getStorage(app), `property/${id}`));
        getProperties();
    }

    const getProperties = async () => {
        let x = [];
        await getDocs(collection(getFirestore(app), 'properties')).then(results => results.forEach(result => x.push([result.id, result.data()])));
        setProperties(x);
    }

    const handleGallery = async images => {
        let current_gallery = [];
        await Array.from(images).forEach(i => current_gallery.push({ image: i, imagePrev: URL.createObjectURL(i) }));
        setGallery(current_gallery);
    }

    const getProfile = () => {
        if (!localStorage.getItem('userId')) return window.location.replace('/login');
        getDoc(doc(getFirestore(app), 'users', localStorage.getItem('userId')))
            .then(result => setProfile([result.id, result.data()]));
    }

    useEffect(() => {
        getProfile();
        getProductCategories();
        getPropertyCategories();
        getServiceCategories();
    }, []);


    // orders

    var formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'PHP' });
    const [orders, setOrders] = useState();

    const cancelOrder = orderId => {
        updateDoc(doc(getFirestore(app), 'orders', orderId), { status: 'cancelled' });
        alert('You have successfully cancelled your order!');
        getOrders();
        return;
    }

    const getOrders = async status => {
        let x = [];

        if (status) {
            await getDocs(query(collection(getFirestore(app), 'orders'), where('status', '==', status), orderBy('date', 'desc')))
                .then(results => results.forEach(i => x.push([i.id, i.data()])));
        } else {
            await getDocs(query(collection(getFirestore(app), 'orders'), orderBy('date', 'desc')))
                .then(results => results.forEach(i => x.push([i.id, i.data()])));
        }

        setOrders(x);
        return;
    }
    
    useEffect(() => {
        getOrders();
    }, []);

    return isUser ? (
        <>
            <Nav />
            <Hero       profile={profile} />
            <Personal   profile={profile} />

            <div className="container-fluid bg-light min-vh-100 p-4">
                <h2>My Orders</h2>

                <select className="form-select mb-4" onChange={data => { data.target.value ? getOrders(data.target.value) : getOrders() }}>
                    <option value={null}>All</option>
                    <option value="To pay">To pay</option>
                    <option value="To ship">To ship</option>
                    <option value="To receive">To receive</option>
                    <option value="Completed">Completed</option>
                    <option value="Cancelled">Cancelled</option>

                </select>
                
                <table className="table table-sm table-borderless text-center">
                    
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col">Product</th>
                            <th scope="col">Date Ordered</th>
                            <th scope="col">Quantity</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Seller</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        
                        {
                            orders && orders.map(i => (
                                <tr>

                                    <td className="align-middle">
                                        <img
                                            src={i[1].item.image_url}
                                            className="img-fluid"
                                            onClick={() => window.location.replace('/product/' + i[1].item.id)}
                                            style={{ borderRadius: 20, width: 66, height: 66 }}
                                            role="button"
                                            alt=""
                                        />
                                    </td>

                                    {/* product name */}
                                    <td className="align-middle">
                                        <a href={`/product/${i[1].item.id}`} className="d-block">{ i[1].item.name }</a>
                                        <small className="text-muted">{ i[1].item.description.substring(0, 40) }</small>
                                    </td>

                                    {/* date ordered */}
                                    <td className="align-middle">{ moment(i[1].date.toDate()).format('LL') }</td>

                                    {/* quantity */}
                                    <td className="align-middle">{ i[1].item.quantity }</td>

                                    {/* amount */}
                                    <td className="align-middle text-success fw-bold">{ formatter.format(i[1].item.amount) }</td>

                                    {/* seller */}
                                    <td className="align-middle">{ i[1].seller.name }</td>

                                    {/* status */}
                                    <td className="align-middle">{ i[1].status }</td>

                                    {/* action */}
                                    <td className="align-middle">
                                        { i[1].status === 'ordered' ? <button className="btn btn-sm btn-danger" onClick={() => cancelOrder(i[0])}>Cancel Order</button> : <></> }
                                        
                                    </td>
                                </tr>
                            ))
                        }

                    </tbody>
                </table>
            </div>

            {/* MODAL */}

            <div className="modal fade" id="itemsModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Order</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row g-2 text-center">
                                {
                                    itemsPrev && itemsPrev.map(i => (
                                        <div className="col-md-3">
                                            <div className="h-100 rounded-3 border bg-success text-light">
                                                <img
                                                    src={i.image_url}
                                                    className="img-fluid"
                                                    alt=""
                                                />

                                                <span className="d-block">{i.name}</span>
                                                <span className="d-block">Quantity: {i.quantity}</span>
                                                <span className="d-block">Price: {i.price}</span>
                                                <span className="d-block">Amount: {i.amount}</span>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ADD PRODUCT */}
            <div className="modal fade" id="addProduct" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Add New Product</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img
                                        src={imagePrev}
                                        className="img-fluid rounded-3 shadow w-100 mb-2"
                                        alt=""
                                    />
                                </div>

                                <div className="col-lg-6">

                                    <div className="mb-3">
                                        <label className="form-label">Product Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Product Name"
                                            onChange={data => setName(data.target.value)}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Product Category</label>
                                        <select className="form-select" onChange={data => setCategory(data.target.value)}>
                                            <option value="" disabled selected>Select A Category</option>
                                            { productCategories.map(i => <option value={i[1].name}>{i[1].name}</option>) }
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Product Description</label>
                                        <textarea className="form-control" placeholder="Product Description" cols="30" rows="2" onChange={data => setDescription(data.target.value)}></textarea>
                                    </div>

                                    {/* variants */}
                                    <div className="mb-3">
                                        <label className="form-label">Product Variants</label>

                                        <div className="mb-2 input-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Product Variants"
                                                onChange={data => setVariant(data.target.value)}
                                            />

                                            <button
                                                className='btn btn-dark'
                                                onClick={() => {
                                                    setVariants([...variants, variant])}
                                                }
                                            >Create Variant</button>
                                        </div>

                                        {
                                            variants.map(i => (
                                                <div className="d-flex align-items-center justify-content-between p-2 bg-secondary text-light mb-1 rounded-3">
                                                    <span className="">{i}</span>
                                                    <i className='bi-x-lg' role="button" onClick={() => {
                                                        let x = variants.filter(j => j !== i);
                                                        setVariants(x);
                                                    }}></i>
                                                </div>
                                            ))
                                        }
                                        
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Product Price</label>
                                        <input type="number" className="form-control" placeholder="Price" onChange={data => setPrice(data.target.value)} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Product Image</label>
                                        <input type="file" className="form-control mb-2" onChange={data => {setImagePrev(URL.createObjectURL(data.target.files[0])); setImage(data.target.files[0])}} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Product Gallery</label>
                                        <input type="file" className="form-control mb-2" multiple onChange={data => handleGallery(data.target.files)} />
                                    </div>

                                    {/* GALLERY IMAGES */}
                                    <div className="mb-3">
                                        { gallery.map(i => <img src={i.imagePrev} className="img-fluid rounded-3 shadow m-1" style={{ width: 100 }} alt="" />) }
                                    </div>

                                    <button className="btn btn-success w-100" onClick={addProduct} disabled={ addProductLoading ? true:false }>
                                        { addProductLoading ? <div className="spinner-border text-light me-2" style={{ height: 18, width: 18 }} role="status"></div>:<></> }
                                        { addProductLoading ? 'Adding product ...':'Add Product' }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ADD FOOD */}
            <div className="modal fade" id="addFood" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Add New Food</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={imagePrev} className="img-fluid rounded-3 shadow w-100 mb-2" alt="" />
                                </div>

                                <div className="col-lg-6">
                                    <div className="mb-3">
                                        <label className="form-label">Food Name</label>
                                        <input type="text" className="form-control" placeholder="Food Name" onChange={data => setName(data.target.value)} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Food Category</label>
                                        <select className="form-select" onChange={data => setCategory(data.target.value)}>
                                            <option value="" disabled selected>Select A Category</option>
                                            { productCategories.map(i => <option value={i[1].name}>{i[1].name}</option>) }
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Food Description</label>
                                        <textarea className="form-control" placeholder="Food Description" cols="30" rows="2" onChange={data => setDescription(data.target.value)}></textarea>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Food Price</label>
                                        <input type="number" className="form-control" placeholder="Price" onChange={data => setPrice(data.target.value)} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Food Image</label>
                                        <input type="file" className="form-control mb-2" onChange={data => {setImagePrev(URL.createObjectURL(data.target.files[0])); setImage(data.target.files[0])}} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Food Gallery</label>
                                        <input type="file" className="form-control mb-2" multiple onChange={data => handleGallery(data.target.files)} />
                                    </div>

                                    {/* GALLERY IMAGES */}
                                    <div className="mb-3">
                                        { gallery.map(i => <img src={i.imagePrev} className="img-fluid rounded-3 shadow m-1" style={{ width: 100 }} alt="" />) }
                                    </div>

                                    <button className="btn btn-success w-100" onClick={addProduct} disabled={ addProductLoading ? true : false }>
                                        { addProductLoading ? <div className="spinner-border text-light me-2" style={{ height: 18, width: 18 }} role="status"></div>:<></> }
                                        { addProductLoading ? 'Adding product ...':'Add Product' }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* ADD SERVICE */}
            <div className="modal fade" id="addService" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Add New Service</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={imagePrev} className="img-fluid rounded-3 shadow w-100 mb-2" alt="" />
                                </div>

                                <div className="col-lg-6">
                                    <div className="mb-3">
                                        <label className="form-label">Service Name</label>
                                        <input type="text" className="form-control" placeholder="Product Name" onChange={data => setName(data.target.value)} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Service Category</label>
                                        <select className="form-select" onChange={data => setCategory(data.target.value)}>
                                            <option value="" disabled selected>Select A Category</option>
                                            { serviceCategories.map(i => <option value={i[1].name}>{i[1].name}</option>) }
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Service Description</label>
                                        <textarea className="form-control" placeholder="Product Description" cols="30" rows="2" onChange={data => setDescription(data.target.value)}></textarea>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Service Price</label>
                                        <input type="number" className="form-control" placeholder="Price" onChange={data => setPrice(data.target.value)} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Service Image</label>
                                        <input type="file" className="form-control mb-2" onChange={data => {setImagePrev(URL.createObjectURL(data.target.files[0])); setImage(data.target.files[0])}} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Service Gallery</label>
                                        <input type="file" className="form-control mb-2" multiple onChange={data => handleGallery(data.target.files)} />
                                    </div>

                                    {/* GALLERY IMAGES */}
                                    <div className="mb-3">
                                        { gallery.map(i => <img src={i.imagePrev} className="img-fluid rounded-3 shadow m-1" style={{ width: 100 }} alt="" />) }
                                    </div>

                                    <button className="btn btn-success w-100" onClick={addService} disabled={ addProductLoading ? true:false }>
                                        { addProductLoading ? <div className="spinner-border text-light me-2" style={{ height: 18, width: 18 }} role="status"></div>:<></> }
                                        { addProductLoading ? 'Adding service ...':'Add service' }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* LIST PROPERTY */}
            <div className="modal fade" id="listProperty" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">List Property</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6">
                                    <img src={imagePrev} className="img-fluid rounded-3 shadow w-100 mb-2" alt="" />
                                </div>

                                <div className="col-lg-6">
                                    <div className="mb-3">
                                        <label className="form-label">Property Name</label>
                                        <input type="text" className="form-control" placeholder="Product Name" onChange={data => setName(data.target.value)} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Property Category</label>
                                        <select className="form-select" onChange={data => setCategory(data.target.value)}>
                                            <option value="" disabled selected>Select A Category</option>
                                            { propertyCategories.map(i => <option value={i[1].name}>{i[1].name}</option>) }
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Property Description</label>
                                        <textarea className="form-control" placeholder="Product Description" cols="30" rows="2" onChange={data => setDescription(data.target.value)}></textarea>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Property Price</label>
                                        <input type="number" className="form-control" placeholder="Price" onChange={data => setPrice(data.target.value)} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Property Attributes</label>
                                        <div className="input-group">

                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Sqm."
                                                onChange={data => setSize(data.target.value)}
                                            />

                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Bedroom"
                                                onChange={data => setBedroom(data.target.value)}
                                            />

                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Comfort Room"
                                                onChange={data => setComfortroom(data.target.value)}
                                            />

                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Parking Space"
                                                onChange={data => setParking(data.target.value)}
                                            />

                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Property Image</label>
                                        <input type="file" className="form-control mb-2" onChange={data => {setImagePrev(URL.createObjectURL(data.target.files[0])); setImage(data.target.files[0])}} />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Property Gallery</label>
                                        <input type="file" className="form-control mb-2" multiple onChange={data => handleGallery(data.target.files)} />
                                    </div>

                                    {/* GALLERY IMAGES */}
                                    <div className="mb-3">
                                        { gallery.map(i => <img src={i.imagePrev} className="img-fluid rounded-3 shadow m-1" style={{ width: 100 }} alt="" />) }
                                    </div>

                                    <button className="btn btn-success w-100" onClick={addProperty} disabled={ addProductLoading ? true:false }>
                                        { addProductLoading ? <div className="spinner-border text-light me-2" style={{ height: 18, width: 18 }} role="status"></div>:<></> }
                                        { addProductLoading ? 'Listing property ...':'List Property' }
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* CUSTOMERS */}
            <div className="modal fade" id="listProperty" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Customers</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-sm table-borderless text-center">
                                <thead>
                                    <tr>
                                        {/* <th scope="col">Order ID</th> */}
                                        <th scope="col">Customer</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">Phone</th>
                                        <th scope="col">Address</th>
                                        <th scope="col">Items</th>
                                        <th scope="col">Total</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* {
                                        orders && orders.map(order => (
                                            <tr>
                                                <td className="fw-bold">{order[0]}</td>
                                                <td>{order[1].name}</td>
                                                <td>{order[1].email}</td>
                                                <td>{order[1].phone}</td>
                                                <td>{order[1].address}</td>
                                                <td>
                                                    <button className="btn btn-sm btn-dark" data-bs-toggle="modal" data-bs-target="#itemsModal" onClick={() => setItemsPrev(order[1].items)}>View Items</button>
                                                </td>
                                                <td>{order[1].total}</td>
                                                <td>
                                                    <button className="btn btn-sm btn-outline-danger rounded-circle me-2" onClick={() => rejectOrder(order[0])}><i className="bi-x"></i></button>
                                                    <button className="btn btn-sm btn-outline-success rounded-circle" onClick={() => acceptOrder(order[0])}><i className="bi-check"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                    } */}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* SELLER ACCOUNT VERIFICATION */}
            <div className="modal fade" id="verifySellerAccount" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Customers</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-2">
                                <label className="form-label"></label>
                                <input type="text" className="form-control" />
                            </div>
                            <input type="text" name="" id="" className="form-control" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    ):<Navigate to="/" />;
}